<template>
  <a-select
    class="container"
    show-search
    allowClear
    placeholder="快速搜索功能和设置"
    :defaultActiveFirstOption="false"
    @search="handleSearch"
    :filter-option="false"
    @change="handleChange"
    v-model="CurrentValue"
  >
    <a-select-opt-group v-for="(item,index) in list" :key="index">
      <span slot="label"><a-icon type="right-circle" /> {{item.name}}</span>
      <a-select-option :value="`${item.id}_${i}_${item.router_name}`" v-for="(keyword,i) in item.keywords" :key="i">
        {{keyword}}
      </a-select-option>
    </a-select-opt-group>
  </a-select>
</template>

<script>
import { ROUTER_LIST } from './data'
export default {
  data() {
    return {
      SearchValue: '',
      CurrentValue: []
    }
  },
  watch: {
  },
  computed:{
    list() {
      const SearchValue = this.SearchValue
      const dataObj = ROUTER_LIST
      let newList = []
      dataObj.map(item=>{
        const keywords = item.keywords.filter(keyword=>{
          return keyword.indexOf(SearchValue) != -1
        })
        if(keywords.length > 0){
          newList.push({
            id: item.id,
            name: item.name,
            router_name: item.router_name,
            keywords: keywords
          })
        }
      })
      return newList
    }
  },
  created() {
  },
  methods: {
    handleSearch(value) {
      this.SearchValue = value
    },
    handleChange(value) {
      if(!value) return false
      const router_name = value.split("_")[2]
      if(this.$router.currentRoute.name == router_name){
        this.$message.success("此功能就在当前页面")
      }else{
        this.$router.push({name:router_name})
      }
      this.CurrentValue = []
      this.SearchValue = ''
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  border: unset;
}
</style>
